import type { FeatureConfigProvider } from './interfaces/feature-config.provider'
import type {
  TaggingBannerConfig,
  TaggingBannerConfigProvider,
} from './interfaces/tagging-audit-config.provider'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { EngagementCategoryEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-category.enum'
// @ts-strict-ignore
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { ColorEnum, EngagementToolEnum, FeatureIdEnum } from '../enums'

import Context = interfaces.Context

export function getTaggingBannerConfigProvider({
  container,
}: Context): TaggingBannerConfigProvider {
  const getFeatureConfigProvider = container.get<FeatureConfigProvider>(TYPES.FeatureConfigProvider)

  return (id: EngagementCategoryEnum | EngagementToolEnum): TaggingBannerConfig => {
    const featureId = getFeatureId(id)
    const domain = getDomain(id)

    const featureConfig = getFeatureConfigProvider(featureId, { domain })

    return {
      featureName: featureConfig.name,
      color: getColor(featureId) ?? featureConfig.color,
    }
  }
}

function getColor(
  id: EngagementCategoryEnum | EngagementToolEnum | FeatureIdEnum,
): ColorEnum | undefined {
  const colorOptions = {
    [EngagementCategoryEnum.ANALYTICS]: ColorEnum.BLUE_75,
  }
  return colorOptions[id]
}

function getDomain(id: EngagementCategoryEnum | EngagementToolEnum): DomainEnum {
  switch (id) {
    case EngagementToolEnum.NAVIGATION_CONFIGURATIONS:
      return DomainEnum.BROWSE
    default:
      return DomainEnum.SEARCH
  }
}

function getFeatureId(id: EngagementCategoryEnum | EngagementToolEnum): FeatureIdEnum {
  const featuresIds = {
    [EngagementToolEnum.OVERALL]: FeatureIdEnum.OVERALL,
    [EngagementToolEnum.QUERIES]: FeatureIdEnum.QUERIES,
    [EngagementToolEnum.CATEGORIES]: FeatureIdEnum.CATEGORIES,
    [EngagementCategoryEnum.INSIGHTS]: FeatureIdEnum.INSIGHTS,
    [EngagementToolEnum.NOW]: FeatureIdEnum.NOW,
    [EngagementToolEnum.ORIGINS]: FeatureIdEnum.ORIGINS,
    [EngagementToolEnum.KEYWORDS]: FeatureIdEnum.KEYWORDS,
    [EngagementCategoryEnum.PLAY]: FeatureIdEnum.PLAY,
    [EngagementToolEnum.EQUALIZE]: FeatureIdEnum.EQUALIZE,
    [EngagementToolEnum.SYNONYMS]: FeatureIdEnum.SYNONYM,
    [EngagementToolEnum.BLACKLIST]: FeatureIdEnum.BLACKLIST,
    [EngagementToolEnum.PROMOTIONS]: FeatureIdEnum.PROMOTION,
    [EngagementToolEnum.REDIRECTIONS]: FeatureIdEnum.REDIRECTION,
    [EngagementToolEnum.RELATED_TAGS]: FeatureIdEnum.RELATED_TAGS,
    [EngagementToolEnum.NEXT_QUERIES]: FeatureIdEnum.NEXT_QUERIES,
    [EngagementToolEnum.EXPLAIN]: FeatureIdEnum.EXPLAIN,
    [EngagementToolEnum.AUDIT]: FeatureIdEnum.AUDIT,
    [EngagementToolEnum.SEARCH_CONFIGURATIONS]: FeatureIdEnum.CONFIGURATION,
    [EngagementToolEnum.NAVIGATION_CONFIGURATIONS]: FeatureIdEnum.CONFIGURATION,
  }

  return featuresIds[id] ?? id
}
